module.exports = __webpack_public_path__ + "static/img/bg_reward_item_blue.59ec4054.svg";